<template>
  <div id="tagDetailModal" class="content">
    <modal :show.sync="shouldShow" @hidden="onClickCancel" v-on:close="onClickCancel" footerClasses="justify-content-center" type="notice">
      <h4 slot="header" class="modal-title">
        <b>띄워주기</b>
      </h4>
      <div class="row">
        <div class="col-sm-6">
          <h4 class="card-title text-left">시작시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="시작시간">
                <el-date-picker type="datetime" placeholder="시작시간" v-model="startTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <h4 class="card-title text-left">종료시간</h4>
          <div class="row">
            <div class="col-md-12 text-left">
              <base-input placeholder="종료시간">
                <el-date-picker type="datetime" placeholder="종료시간" v-model="endTime"></el-date-picker>
              </base-input>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="justify-content-center">
        <base-button class="footer-buttons col-6" type="success" round @click.native="onClickConfirm">확인</base-button>
        <base-button class="footer-buttons col-6" type="danger" round @click.native="onClickCancel">취소</base-button>
      </div>
    </modal>
  </div>
</template>
<script>
import { BaseInput, Modal } from "@/components/index";
import BaseButton from "@/components/BaseButton";

export default {
  name: "CollectionDetailModal",
  components: {
    BaseButton,
    BaseInput,
    Modal,
  },
  data() {
    return {
      startTime: null,
      endTime: null,
    };
  },
  props: {
    artistId: Array,
    unitId: Number,
    tagId: Number,
    shouldShow: {
      type: Boolean,
      required: true,
    },
    onConfirm: {
      type: Function,
      required: true,
    },
    onCancel: {
      type: Function,
      required: true,
    },
  },
  methods: {
    changeType() {},
    onClickConfirm: async function () {
      await this.onConfirm();
      if (this.startTime === "" || !this.startTime || this.endTime === "" || !this.endTime) {
        Toast.error("시간을 정확히 입력해 주세요");
        return;
      }
      const param = { unitId: this.unitId, artistId: this.artistId, tagId: this.tagId, startTime: this.startTime, endTime: this.endTime };

      return this.$axios
        .post(`/collection/raisedTags`, param)
        .then((res) => {
          window.Toast.success("설정되었습니다");
          this.startTime = null;
          this.endTime = null;

          this.onClickCancel();
        })
        .catch((error) => {
          window.Toast.error(error.response.data.error.message);
        });
    },
    onClickCancel: async function () {
      await this.onCancel();
    },
    getArtistInfo(memberId) {
      this.memberIds = memberId;
    },
  },
};
</script>
<style lang="scss">
#tagDetailModal .modal-dialog {
  max-width: 400px !important;
}

.member-select {
  margin-bottom: 30px;
}

.footer {
  .footer-buttons {
    width: 100px;
  }
}
</style>
